export default __webpack_public_path__ + "static/media/sso.5d1fa590.png";